import { render, staticRenderFns } from "./UserPresenceDetectorDevices.vue?vue&type=template&id=50dd1d0e&scoped=true"
import script from "./UserPresenceDetectorDevices.vue?vue&type=script&lang=js"
export * from "./UserPresenceDetectorDevices.vue?vue&type=script&lang=js"
import style0 from "./UserPresenceDetectorDevices.vue?vue&type=style&index=0&id=50dd1d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd1d0e",
  null
  
)

export default component.exports